<template>
  <div class="tes-card row" :class="{ swapped: index % 2 === 1 }">
    <div class="side-a col col-5 sm-offset-0 sm-6" :class="{ 'offset-1': index % 2 === 0 }">
      <nuxt-link :to="`/success-stories/${data.slug}/`" :data-event="`story_${index + 1}.click`">
        <div class="img" style="--ratio: calc(435 / 330);">
          <img loading="lazy" :src="`${$config.imagesUrl}/success-stories/${data.img}`" :alt="data.name">
        </div>
        <h3>{{ data.name }}</h3>
        <p class="body-1">
          {{ data.description }}
        </p>
        <ButtonArrow
          class="btn-desktop"
          type="span"
          text="Read story"
        />
      </nuxt-link>
    </div>
    <div class="side-b col col-5 sm-offset-0 sm-6" :class="{ 'offset-1': index % 2 === 1 }">
      <div>
        <h4 class="ttl">
          {{ data.title }}
        </h4>
        <template v-if="data.courses.length || data.coursesTaken">
          <p v-if="data.coursesTaken" class="courses-taken">
            <span class="number">{{ data.coursesTaken }}</span><span> Courses<br>taken</span>
          </p>
          <div v-if="data.courses.length" class="courses">
            <p v-for="(course, i) in data.courses" :key="i" class="pill">
              <nuxt-link
                :to="`/courses/${course.slug}/`"
                class="pill caption"
              >
                {{ course.name }}
              </nuxt-link>
            </p>
          </div>
        </template>
        <div class="quote body-1">
          {{ data.quote }}
        </div>
      </div>
    </div>
    <ButtonArrow
      class="btn-mobile"
      type="nuxt-link"
      :to="`/success-stories/${data.slug}/`"
      text="Read story"
    />
  </div>
</template>

<script>
import ButtonArrow from '@itbpbg/lms-components/src/components/ButtonArrow';

export default {
  components: { ButtonArrow },
  props: {
    data: { type: Object, default: () => {}, required: true },
    index: { type: Number, required: true },
  },
};
</script>

<style lang="scss" scoped>
  .tes-card {
    display: flex;

    &.swapped .side-b {
      order: -1;
    }

    + .tes-card {
      margin-top: var(--spacing-60);
    }

    .btn-mobile {
      display: none;
    }

    .img {
      border-radius: 10px;
      overflow: hidden;
      margin-bottom: var(--spacing-36);
    }

    .side-a.offset-1,
    .side-b.offset-1 {
      padding-left: 50px;
    }

    .side-a:not(.offset-1),
    .side-b:not(.offset-1) {
      padding-right: 50px;
    }

    .side-a {
      a {
        display: block;
        color: inherit;
      }

      .body-1 {
        color: var(--main-dark-shade-3);
        margin-bottom: var(--spacing-36);
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }

    .side-b {
      > div {
        display: block;
        color: inherit;
        border-radius: 10px;
        background-color: var(--main-light-shade-1);
        padding: var(--spacing-32) 44px;
      }

      .ttl {
        font-size: 32px;
        font-weight: 400;
      }

      .courses-taken {
        color: var(--main-dark-shade-3);
        line-height: 19px;

        .number {
          color: var(--main-dark-shade-0);
          font-size: 48px;
          line-height: 48px;
          font-weight: 500;
          float: left;
          margin-right: 10px;

          + span {
            vertical-align: middle;
          }
        }
      }

      .courses {
        .pill {
          display: block;
          margin: 0;

          a {
            display: inline-block;
            max-width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            border-radius: 100px;
            background-color: var(--main-dark);
            padding: 7px 16px;
            margin: 0;
            color: var(--main-light);
          }
        }
      }

      .quote {
        margin-top: var(--spacing-32);
        padding-top: var(--spacing-32);
        border-top: 1px solid rgba(0, 0, 0, 0.1);

        &:before {
          content: '';
          width: 31px;
          height: 22px;
          background-image: url('../assets/images/icon-quote-testimonials.png');
          image-rendering: -webkit-optimize-contrast;
          background-size: cover;
          display: block;
          margin-bottom: 24px;
        }
      }
    }
  }

  @include bp($bp-tablet) {
    .tes-card {
      .side-b {
        > div {
          padding: var(--spacing-32) var(--spacing-24);
        }
      }
    }
  }

  @include bp($bp-mobile) {
    .tes-card {
      .side-a.offset-1,
      .side-b.offset-1 {
        padding-left: var(--spacing-12);
      }

      .side-a:not(.offset-1),
      .side-b:not(.offset-1) {
        padding-right: var(--spacing-12);
      }

      .side-a {
        h3 {
          font-size: 24px;
        }

        .body-1 {
          font-size: 18px;
        }
      }

      .side-b {
        .ttl {
          font-size: 26px;
        }

        .body-1 {
          font-size: 18px;
        }
      }
    }
  }

  @include bp($bp-phone) {
    .tes-card {
      &.swapped .side-b {
        order: 0;
      }

      .btn-desktop {
        display: none;
      }

      .btn-mobile {
        display: block;
        padding-left: var(--spacing-12);
        margin-top: var(--spacing-36);
      }
      .side-b > div {
        padding: var(--spacing-32) 32px;
      }
    }
  }
</style>
